import moment from 'moment';
import { useNavigate } from 'react-router';
import { Center, Column, Divider, Row, Text } from '~/commonComponents';
import { CloseCircleSolidIcon, ContinueCircleIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';
import './styles.scss';
import { IDraftJobCardProps } from './Types';
import { getProfessionNameByCode } from '~/utils/ProfessionUtils';

export const DraftJobCard = ({
  id,
  lastSavedAt,
  office,
  professionType,
  title,
  onDeleteDraft,
}: IDraftJobCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/permanent-jobs/postings/${id}`);
  };

  return (
    <Row
      alignItems="center"
      backgroundColor={Colors.white}
      borderRadius={10}
      boxShadow="0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 1px rgba(0, 0, 0, 0.15)"
      className="draft-job-card"
      display="grid"
      gridTemplateColumns="1fr 20%"
      paddingBlock={12}
      position="relative"
    >
      <Column gap={6} marginLeft={36}>
        <Text bold textDecoration="underline">
          {title || 'UNTITLED'}
        </Text>
        <Text>{office?.name || 'No Office Selected'}</Text>
        <Row alignItems="center" gap={12}>
          <Text>
            {professionType
              ? getProfessionNameByCode(professionType)
              : 'No Professional Type Selected'}
          </Text>
          <Divider width={1} height={12} marginVertical={0} />
          <Text color={Colors.neutral_400} fontSize={14} italic>
            Draft saved on {moment(lastSavedAt).format('ddd, MMM D, YYYY')}
          </Text>
        </Row>
      </Column>
      <Row
        alignItems="center"
        className="btn"
        gap={8}
        justifyContent="flex-end"
        marginRight={36}
        role="button"
        onClick={handleClick}
      >
        <ContinueCircleIcon />
        <Text bold fontSize={18}>
          Continue
        </Text>
      </Row>
      <Center
        position="absolute"
        right={-8}
        role="button"
        top={-8}
        cursor="pointer"
        filter="drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1))"
        onClick={() => onDeleteDraft?.(id)}
      >
        <CloseCircleSolidIcon size={32} />
      </Center>
    </Row>
  );
};
